import utils from 'utils/utils';

const PluginModel = function() {
    this.player = null;
    this.el = null;
};

PluginModel.prototype = {
    getName: function() {
        throw new Error('getName() method has to be implemented');
    },

    setup: function() {},
    destroy: function() {},

    setPlayer: function(player) {
        this.player = player;
        this.setup(player);
    }
};

PluginModel.extend = utils.model.extend;

utils.extend(PluginModel.prototype, utils.Events);

export default PluginModel;
